import { Alert, Button, Container, Flex } from "@mantine/core";
import React from "react";

const isFailedToFetchError = (error: any): boolean =>
	typeof error?.message === "string" &&
	/Failed to fetch dynamically imported module/.test(error.message);

function ErrorFallback({
	error,
	resetError,
}: {
	error: unknown;
	resetError: () => void;
}) {
	if (isFailedToFetchError(error)) {
		return <div />;
	}

	return (
		<Container h="100%" p="lg">
			<Flex direction="column" align="center" justify="center">
				<Alert color="red" title="Error">
					{(error as any)?.message || "An error occurred"}
				</Alert>
				<Button onClick={resetError} variant="subtle">
					Try again
				</Button>
			</Flex>
		</Container>
	);
}

class PlainErrorBoundary extends React.Component<
	{ children: React.ReactNode },
	{ error: any; hasError: boolean }
> {
	constructor(props: { children: React.ReactNode }) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error: any) {
		return { hasError: true, error };
	}

	componentDidCatch(error: any) {
		console.error(error);
	}

	render() {
		if (this.state.hasError) {
			return (
				<ErrorFallback
					error={this.state.error}
					resetError={() => this.setState({ hasError: false })}
				/>
			);
		}
		return this.props.children;
	}
}

export default PlainErrorBoundary;
export { ErrorFallback };
